export default __webpack_public_path__ + "static/media/791.ffc372c5.gif";